import React from 'react';
import { node, arrayOf, oneOfType, number } from 'prop-types';
import { Transition } from 'react-transition-group';

export const DURATION = 250;

const propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired,
  duration: number,
};

const defaultProps = {
  duration: DURATION,
};

const defaultStyle = {
  opacity: 0,
};

const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

const Fade = ({ children, in: inProp, duration, ...transitionProps }) => {
  const transition = `opacity ${duration}ms ease-in-out`;

  return (
    <Transition in={inProp} timeout={duration} {...transitionProps}>
      {state => (
        <div
          style={{
            transition,
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        >
          {children}
        </div>
      )}
    </Transition>
  );
};

export default Fade;

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;
